import { SortingRule } from 'react-table';
import { SelectionHandler } from '../../utils/SelectionHandler';
import { IBaseGridData } from '../types';
import { IDataGridProps, IDataGridState } from './types';

export function getInitialState<T extends IBaseGridData>({
  columns,
  data,
  initialState: {
    filters = [],
    multiSelectActive = false,
    page = 0,
    pageSize = 25,
    pageSizeOptions = [15, 25, 50, 100],
    sort = [],
    selected = [],
  } = {},
  multiSelect,
  onFetchData,
  ...props
}: IDataGridProps<T>): IDataGridState<T> {
  const resolvedSelected = props.selected ? props.selected : selected;
  const selectedRows = resolvedSelected.map((id) => {
    const actualRow = data.find((item) => item.id === id);
    return actualRow || ({ id } as T);
  });

  return {
    columns,
    filters,
    isRefreshing: false,
    mode: !!onFetchData ? 'remote' : 'local',
    multiSelectActive: multiSelectActive || multiSelect === 'always',
    page,
    pageSize,
    pageSizeOptions,
    searchFilter: [],
    searchableColumns: columns
      .filter((column) => (column.hasOwnProperty('searchable') ? column.searchable : true))
      .map((column) => column.accessor),
    selectionHandler: new SelectionHandler(selectedRows),
    showDisplay: !!selected.length,
    sort: sort.map((initialSort: SortingRule & { sort: string }) => {
      const newSort: { id: string; sort?: string; asc?: boolean; desc?: boolean } = {
        id: initialSort.id,
        sort: initialSort.sort,
      };
      if (initialSort.sort === 'asc') {
        newSort.asc = true;
      }
      if (initialSort.sort === 'desc') {
        newSort.desc = true;
      }
      return newSort as SortingRule;
    }),
    viewSelected: false,
  };
}

export function getSelectionUpdateState<T extends IBaseGridData>(
  selectionHandler: SelectionHandler<T>,
  props: IDataGridProps<T>,
  state: IDataGridState<T>,
) {
  const numSelected = selectionHandler.selected.length;

  return {
    multiSelectActive: props.multiSelect === 'always' || numSelected > 1,
    selectionHandler,
    showDisplay: !!props.displayPanel && !!numSelected,
    viewSelected: state.viewSelected && !numSelected ? false : state.viewSelected,
    page: state.viewSelected && !numSelected ? 0 : state.page,

    // seachfilter change will cause react-table to try to reload, otherwise the filter changes but data does not.
    searchFilter: state.searchFilter && !numSelected ? state.searchFilter.slice() : state.searchFilter,
  };
}
